import React from 'react';

import { UserAvatar } from '@/components/UserAvatar';

interface AssigneeMemberDisplayProps {
  name?: string;
  email: string;
  /** User's unique ID — used for deterministic avatar color (stable across name changes). */
  userId?: string;
  size?: 'xs' | 'sm';
}

export const AssigneeMemberDisplay: React.FC<AssigneeMemberDisplayProps> = ({
  name,
  email,
  userId,
  size = 'sm',
}) => {
  const displayName = name || email;
  const showEmail = name && name !== email;

  return (
    <div className="flex items-center gap-2">
      <UserAvatar name={name} email={email} userId={userId} size={size} />
      <div className="flex flex-col min-w-0">
        <span className="text-sm truncate">{displayName}</span>
        {showEmail && <span className="text-xs text-muted-foreground truncate">{email}</span>}
      </div>
    </div>
  );
};
